import React from 'react';
import photo from '../images/author.png';

export default function HomeSection() {
  return (
    <section id="home" className="section hero-section">
      <div className="hero">
        {/* Background Ambient Glows */}
        <div className="hero-glow hero-glow-1"></div>
        <div className="hero-glow hero-glow-2"></div>
        
        <div className="hero-container">
          <div className="hero-content fade-in-up">
            <p className="hero-tag">Computer Engineering Student</p>
            <h1 className="hero-name gradient-text">
              BAITA,<br />
              JHON JEREMIE
            </h1>
            <h2 className="hero-title">Aspiring Software Developer | Tech Enthusiast</h2>
            <p className="hero-description">
              I build clean, modern web experiences and enjoy solving problems through code.
              Focused on creating real-world projects with React, modern tooling, and strong design.
            </p>
          </div>

          <div className="hero-image slide-in-right">
            <div className="image-wrapper floating">
              <div className="image-glow"></div>
              <img src={photo} alt="Professional portrait" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
